import { render, staticRenderFns } from "./CompanyCommercialData.vue?vue&type=template&id=6472a9da"
import script from "./CompanyCommercialData.vue?vue&type=script&lang=js"
export * from "./CompanyCommercialData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports